import { NgModule } from '@angular/core';
import { DefaultHeaderComponent } from './default-header.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ToggleMenuButtonModule } from '../toggle-menu-button/toggle-menu-button.module';

@NgModule({
  declarations: [DefaultHeaderComponent],
  imports: [CommonModule, IonicModule, TranslateModule, ToggleMenuButtonModule],
  exports: [DefaultHeaderComponent],
  providers: [],
})
export class DefaultHeaderModule {}
